export default __webpack_public_path__ + "static/media/win.7f2451c9.mp3";